export const GET_EDITOR_SETTINGS = 'GET_EDITOR_SETTINGS';
export const UPDATE_EDITOR_SETTINGS = 'UPDATE_EDITOR_SETTINGS';
export const CREATE_EDITOR_SETTINGS = 'CREATE_EDITOR_SETTINGS';
